(function () {
    'use strict';

    angular.module("imApp").factory("custGrpMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1006,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1011,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
